import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DeleteCrecaAccountsRequestModel, DeleteCrecaAccountsResponseModel } from "@/features/accounts/creca/services/delete-accounts-model";

export class DeleteCrecaAccountsApi {
  /**
   * クレカ削除API
   */
  public deleteCrecaAccounts = async (
    param: DeleteCrecaAccountsRequestModel
  ): Promise<DeleteCrecaAccountsResponseModel> => {
    const path = `/api/crecaaccounts/crecas`;
    const res = await ApiClient.instance.delete<DeleteCrecaAccountsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
